<template>
    <LoadMoreList :list="list" :load-page="loadMore" :page="2">
        <template #no-data>暂时还没有粉丝</template>
        <div class="fans-box">
            <div class="user-list">
                <div v-for="user in users.data" :key="user.id">
                    <FansUserItem :user="user"></FansUserItem>
                </div>
            </div>
        </div>
    </LoadMoreList>
</template>

<script setup lang="ts">
import UserShowLayout from "@/Components/Layout/UserShowLayout.vue";
import LoadMoreList from "@/Components/Common/LoadMoreList.vue";
import {ref} from "vue";
import http from "@/utils/http";
import FansUserItem from "@/Components/User/FansUserItem.vue";

const {users} = defineProps<{
    users: any
}>()

const list = ref(users.data)
const loadMore = async page => {
    const res = await http.get(location.href, {
        params: {
            page
        }
    })
    return res.data.users.data
}

defineOptions({
    layout: UserShowLayout
})
</script>

<style lang="less">
@media screen and (max-width: 1400px) {
    .fans-box {
        padding: 0 150px !important;
    }
}
</style>

<style scoped lang="less">
.fans-box {
    padding: 0 350px;
    margin-top: 30px;
    display: flex;
    justify-content: center;

    .user-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
}

</style>
